import {Component, Inject, Input} from '@angular/core';
import {L10N_LOCALE, L10nLocale} from 'angular-l10n';

@Component({
  selector: 'storever-header-modal',
  templateUrl: './header-modal.component.html',
  styleUrls: ['./header-modal.component.scss']
})
export class HeaderModalComponent   {

  @Input() title: string;
  @Input() icon: string;

  constructor(@Inject(L10N_LOCALE) public locale: L10nLocale) {  }


}
